import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ImportModalBase } from './import-modal.base';
import {
  rolloverScenario1Options,
} from '../../../../../../../../common/src/tests/integration/rollover/rollover-scenario-1.options';
import {
  salaryVsDividendsScenario1Options,
} from '../../../../../../../../common/src/tests/integration/salary-vs-dividends/salary-vs-dividends-scenario-1.options';
import { OptitaxFileManager } from '../../../core/managers/optitax-file.manager';
import {
  salaryVsDividendsScenario2Options,
} from '../../../../../../../../common/src/tests/integration/salary-vs-dividends/salary-vs-dividends-scenario-2.options';

@Component({
  selector: 'app-import-modal',
  templateUrl: './import-modal.component.html',
  styleUrls: ['./import-modal.component.scss'],
  standalone: false,
})
export class ImportModalComponent extends ImportModalBase implements OnInit, OnDestroy {
  public loading = false;

  constructor(
    activeModal: NgbActiveModal,
    public readonly optitaxFileManager: OptitaxFileManager,
  ) {
    super(activeModal);
  }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
  }

  async importFile() {
    const optitaxFile = await this.optitaxFileManager.importOptitaxFile();
    setTimeout(() => this.activeModal.close(optitaxFile.options), 0);
  }

  rolloverScenario1() {
    this.loading = true;
    setTimeout(() => this.activeModal.close(rolloverScenario1Options), 0);
  }

  salaryVsDividendsScenario1() {
    this.loading = true;
    setTimeout(() => this.activeModal.close(salaryVsDividendsScenario1Options), 0);
  }

  salaryVsDividendsScenario2() {
    this.loading = true;
    setTimeout(() => this.activeModal.close(salaryVsDividendsScenario2Options), 0);
  }
}
